import { render, staticRenderFns } from "./screenMain.vue?vue&type=template&id=5b764a5d&scoped=true"
import script from "./screenMain.vue?vue&type=script&lang=js"
export * from "./screenMain.vue?vue&type=script&lang=js"
import style0 from "./screenMain.vue?vue&type=style&index=0&id=5b764a5d&prod&lang=scss&scoped=true"
import style1 from "./screenMain.vue?vue&type=style&index=1&id=5b764a5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b764a5d",
  null
  
)

export default component.exports